import React, { useState, useEffect } from 'react'

import {
    IpsaGreen,
    IpsaSupplementalBenefitColor,
} from '../../../../../highcharts/HighchartsStyleHelper'
import DisplayRowInformation from './DisplayRowInformation'

const GraphSummaryText = ({ options }) => {
    const [income, setIncome] = useState(null)
    const [deficitWithAdditionalCoverage, setDeficitWithAdditionalCoverage] = useState(null)
    const [deficitWithoutAdditionalCoverage, setDeficitWithoutAdditionalCoverage] = useState(null)
    const [deficitSaved, setDeficitSaved] = useState(null)
    const [totalOriginalIncome, setTotalOriginalIncome] = useState(null)

    const IsValid = (val) => val && val > 0
    const hasValue = (val) => val && val !== 0

    useEffect(() => {
        const {
            aggregateData: {
                totalEstimatedDeficitWithAdditionalCoverage,
                totalEstimatedDeficitWithoutAdditionalCoverage,
                totalDeficitSaved,
                totalEstimatedIncome,
                totalOriginalIncome,
            } = {},
        } = options

        if (IsValid(totalEstimatedIncome)) {
            setIncome({
                color: IpsaGreen,
                text: IsValid(totalOriginalIncome) ? 'New Asset Value' : 'Asset Value',
                value: totalEstimatedIncome,
            })
        } else {
            setIncome(null)
        }

        if (IsValid(totalDeficitSaved)) {
            setDeficitSaved({
                color: IpsaSupplementalBenefitColor,
                text: 'Income Saved',
                value: totalDeficitSaved,
            })
        } else {
            setDeficitSaved(null)
        }

        if (IsValid(totalEstimatedDeficitWithAdditionalCoverage)) {
            setDeficitWithAdditionalCoverage({
                color: 'yellow',
                text: 'Reduced Loss',
                value: totalEstimatedDeficitWithAdditionalCoverage,
            })
        } else {
            setDeficitWithAdditionalCoverage(null)
        }

        if (IsValid(totalEstimatedDeficitWithoutAdditionalCoverage)) {
            setDeficitWithoutAdditionalCoverage({
                color: 'red',
                text: hasValue(totalEstimatedDeficitWithAdditionalCoverage)
                    ? 'Original Loss'
                    : 'Income Loss',
                value: totalEstimatedDeficitWithoutAdditionalCoverage,
            })
        } else {
            setDeficitWithoutAdditionalCoverage(null)
        }

        if (IsValid(totalOriginalIncome)) {
            setTotalOriginalIncome({
                color: '#fff',
                text: 'Original Income Asset',
                value: totalOriginalIncome,
            })
        } else {
            setTotalOriginalIncome(null)
        }
    }, [options])

    if (
        !income &&
        !deficitSaved &&
        !deficitWithAdditionalCoverage &&
        !deficitWithoutAdditionalCoverage &&
        !totalOriginalIncome
    ) {
        return <DisplayRowInformation className="display-row-information" items={null} />
    }

    let items = [
        totalOriginalIncome,
        income,
        deficitWithoutAdditionalCoverage,
        deficitWithAdditionalCoverage,
        deficitSaved,
    ].filter((p) => !!p)

    return <DisplayRowInformation className="display-row-information" items={items} />
}

export default GraphSummaryText
